import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.12.2_@parcel+watcher@2.4.1_@types+node@22.20.1_encoding@0.1.13_eslint@8.57.1_ioredis@5_2jnjin3sf42r5aimyryejqcjjy/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}